<template>
    <div id="app">
        <Header/>
        <router-view/>
    </div>
</template>

<script>

import Header from "@/components/Header";
import {mapActions} from "vuex";

export default {
    name: 'App',
    components: {
        Header
    },
    methods: {
        ...mapActions(['fetchObjects', 'getBrokerData', 'getCabinetData'])
    },
    created() {
        this.fetchObjects().catch(alert);
        this.getBrokerData();
        this.getCabinetData();
        console.log(this.$store.state);
    },
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
}
</style>
